var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"articleDetail"},[_c('p',{staticStyle:{"text-align":"center","font-size":"18px"}},[_vm._v(_vm._s(_vm.info.Title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.info.Text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }